/**
 * @module Tagular
 * @description
 */

const pagesMap = [
  { path: '/', value: 'HOME' },
  { path: '/fiber-merchandising', value: 'FIBER MERCHANDISING' },
  { path: '/plans-pricing', value: 'PLANS PRICING' },
  { path: '/terms', value: 'TERMS' }
];

/**
 * @function getTagularLocation
 * @description
 */
const getTagularLocation = () => {
  const base = new URL( window.location );
  const { pathname } = base;
  const location = pagesMap.filter( ( page ) => page.path === `/${ pathname.split( '/' ).pop() }` )[ 0 ];

  if ( ! location ) {
    return pagesMap[ 0 ].value;
  }

  return location.value;
};

const EVENTS = {
  ElementClicked: 'redventures.usertracking.v3.ElementClicked',
  ElementViewed: 'redventures.usertracking.v3.ElementViewed',
  FieldInputted: 'redventures.usertracking.v3.FieldInputted',
  FormStarted: 'redventures.usertracking.v3.FormStarted',
  FormSubmitted: 'redventures.usertracking.v3.FormSubmitted',
  ProductClicked: 'redventures.usertracking.v3.ProductClicked',
  PageViewed: 'redventures.usertracking.v3.PageViewed',
  ClientErrored: 'redventures.usertracking.v3.ClientErrored'
};

/**
 * @function tagularWrapper
 * @description
 */
const tagularWrapper = ( ...args ) => {
  if ( window?.tagular ) tagular( ...args );
};

/**
 * @function elementClicked
 * @description
 */
export const elementClicked = ( data, event ) => {
  const { target = {} } = event;
  const payload = {
    '@type': EVENTS.ElementClicked,
    webElement: {
      elementType: data?.elementType || target?.type?.toUpperCase() || null,
      location: data?.location || getTagularLocation(),
      position: data?.position || null,
      htmlId: data?.htmlID || target?.id || null,
      text: data?.text || target?.innerText || null
    },
    actionOutcome: data?.actionOutcome || null,
    outboundUrl: data?.outboundUrl || null
  };

  tagularWrapper( 'beam', payload );
};

/**
 * @function elementViewed
 * @description
 */
export const elementViewed = ( data, event ) => {
  const { target = {} } = event;
  const payload = {
    '@type': EVENTS.ElementViewed,
    webElement: {
      elementType: data?.elementType || target?.tageName || null,
      location: data?.location || getTagularLocation(),
      position: data?.position || null,
      htmlId: data?.htmlID || target?.id || null,
      text: data?.text || target?.innerText || null
    }
  };

  tagularWrapper( 'beam', payload );
};

/**
 * @function fieldInputted
 * @description
 */
export const fieldInputted = ( data, event ) => {
  const { target = {} } = event;
  const payload = {
    '@type': EVENTS.FieldInputted,
    userInputField: {
      autofilled: target?.autofilled || data?.autofilled || false,
      fieldType: target?.type || data?.fieldtype || null,
      fieldName: target?.name || data?.fieldname || null,
      fieldId: target?.id || data?.fieldid || null,
      fieldLabel: target?.placeholder || data?.fieldlabel || null
    }
  };

  tagularWrapper( 'beam', payload );
};

/**
 * @function formStarted
 * @description
 */
export const formStarted = ( data ) => {
  const payload = {
    '@type': EVENTS.FormStarted,
    formContext: {
      formType: data?.formType || null,
      formName: data?.formName || null,
      formId: data?.formId || null
    }
  };

  tagularWrapper( 'beam', payload );
};

/**
 * @function formSubmitted
 * @description
 */
export const formSubmitted = ( data ) => {
  const payload = {
    '@type': EVENTS.FormSubmitted,
    formContext: {
      formType: data?.formType || null,
      formName: data?.formName || null,
      formId: data?.formId || null
    }
  };

  tagularWrapper( 'beam', payload );
};

/**
 * @function pageViewed
 * @description
 */
export const pageViewed = () => {
  const payload = {
    '@type': EVENTS.PageViewed
  };

  tagularWrapper( 'beam', payload );
  tagularWrapper( 'pageView', false ); // The third parameter tells Preamp to not redecision
};

/**
 * @function pageScrolled
 * @description
 */
export const pageScrolled = ( data ) => {
  const payload = {
    '@type': EVENTS.PageScrolled,
    scrollDistance: data?.scrollDistance
  };

  tagularWrapper( 'beam', payload );
};

/**
 * @function clientErrored
 * @description
 */
export const clientErrored = ( data ) => {
  const payload = {
    '@type': EVENTS.ClientErrored,
    errorMessage: data?.errorMessage || null,
    errorType: data?.errorType || '0' // UNKNOWN = 0; BLOCKING = 1; NONBLOCKING = 2;
  };

  tagularWrapper( 'beam', payload );
};
